<ngb-carousel  class="carousel position-absolute slide w-100 carousel-fade" >
  <ng-template ngbSlide *ngFor="let imagen of imagenes; let j=index">
    <div class="carousel-inner bg-tour-detail tours-height" >
      <div class="carousel-item active" style="z-index: 0;">
        <img [src]="imagen.imagen" class="d-block " alt="..." style="height: 100% !important; width: -webkit-fill-available; object-fit: cover;">
      </div>
   </div>
  </ng-template>
</ngb-carousel>
  <!-- Hero -->
  <section class="align-items-center d-flex tours-height">
      <div class="position-relative tour-detail-title w-100">
          <div class="container">
              <div class="row mb-5">
                  <div class="col-lg-1">
                      <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
                          <img src="assets/images/body/icons/volver.svg" class="pe-2" alt="">
                          <h4 class="text-white mb-0"> Volver</h4>
                      </a>
                  </div>
              </div>
              <div class="row ">
                  <div class="col-lg-12">
                      <h1 class="mb-1 text-white">{{tourDetail?.nombre_paquete}}</h1>
                  </div>
              </div>
          </div>
      </div>
  </section>

<section class="tour-detail-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-12 col-md-6 pb-2">
        <h4 class="title-bg mb-5">Información del viaje</h4>
        <ul class="list-unstyled info-tour mb-4">
          <li class="d-flex align-items-center pb-3">
            <img src="assets/images/body/tours/salida.svg" class="pe-3" alt="">
            <p class="mb-0">Salida {{tourDetail?.lugar_salida}}</p>
          </li>
          <li class="d-flex align-items-center pb-3">
            <img src="assets/images/body/tours/bus.svg" class="pe-3" alt="">
            <p class="mb-0">{{tourDetail?.id_tipoBus?.tipo}}</p>

          </li>
          <li class="d-flex align-items-center pb-3">
            <img src="assets/images/body/tours/noches.svg" class="pe-3" alt="">
            <p class="mb-0">{{tourDetail?.cantidad_noches}} noches</p>

          </li>
          <li class="d-flex align-items-center pb-3">
            <img src="assets/images/body/tours/hotel.svg" class="pe-3" alt="">
            <p class="mb-0 pe-3">Hotel {{hotel?.data?.categoria_hotel}}</p>
            <div *ngFor="let item of hotelStar">
              <div *ngIf="item===1">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="18.363" height="17.512"
                  viewBox="0 0 18.363 17.512">
                  <path class="estrella-active"
                    d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z"
                    transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1" /></svg>
              </div>
              <div *ngIf="item===0">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="18.363" height="17.512"
                  viewBox="0 0 18.363 17.512">
                  <path
                    d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z"
                    transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1" /></svg>
              </div>
            </div>
          </li>
        </ul>
        <p class="mb-lg-0 mb-3">{{tourDetail?.properties_paquete}}</p>
      </div>
      <div class="col-xl-5 col-xxl-4 col-lg-6 col-md-6 pb-5 bg-primary tours-price ps-0 position-relative">
        <h4 class="align-items-center bg-white d-flex text-primary title-bg">Precio por adulto <img
            src="assets/images/body/tours/price.svg" class="ps-4" alt=""></h4>
        <div class="ps-5 pt-5">
          <div *ngFor="let item of habitacionesPrecio">
            <p class="text-white">Habitación: {{item?.tipo}}</p>
            <h2 class="text-white mb-4">{{item?.precio}} AR$</h2>
          </div>
        </div>
        <img src="assets/images/body/bg-tour-1.svg" class="position-absolute" alt="">
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-lg-6  pb-2">

      </div>
      <div
        class="col-12 col-lg-6 col-xl-5 col-xxl-4 d-flex flex-md-row flex-column justify-content-center align-items-center justify-content-lg-start pb-5 ps-0">
        <a class="text-secondary rounded-pill border border-2 me-md-3 border-secondary nav-link btn-lg btn-outline mb-3"
        [routerLink]="['/','tours', 'tour-itinerary' ,tourDetail?.id]">Ver itinerario</a>
        <a class="text-secondary rounded-pill border border-2 me-md-3 border-secondary nav-link btn-lg btn-outline mb-3"
        [routerLink]="['/','tours', 'tour-excursion' ,tourDetail?.id]">Ver excursiones</a>
      </div>
    </div>
  </div>
</section>
<section class="">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-10">
        <h4 class="title-bg mb-5">Iniciar Reserva</h4>
      </div>
    </div>
    <div class="row d-flex">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-lg-4 z-index-top position-relative ">
        <div class="bg-primary tours-pasajeros ps-0 pb-5 h-100 pe-2">
          <h4 class="align-items-center bg-white d-flex text-primary title-bg">Paso 1 - Pasajeros <img
              src="assets/images/body/tours/pasajeros.svg" class="ps-4" alt=""></h4>
          <div class="ps-5 pt-3">

            <h2 class="text-white mb-1">Cantidad de Pasajeros</h2>
            <p class="text-white">Seleccione la cantidad de pasajeros que viajaran</p>

          </div>

        </div>
      </div>

      <div class="col-xxl-6 col-xl-7 col-lg-8 margin-left- pe-lg-0">
        <div class="ps-4 pt-5 pb-4 bg-grey h-100">
          <div class="row mb-4 me-0 ms-0">
            <div class="col-lg-3 col-6">
              <h3 class="mb-0 pe-3">Adultos</h3>
            </div>
            <div class="col-lg-9 col-6">
              <div class="d-flex flex-row">
                <img src="assets/images/body/tours/menos.svg" style="cursor: pointer;"
                  (click)="plusLessAdult(false,true)" class=" pe-2" alt="">
                <h3 class="mb-0 pe-2">{{reservation?.adultos}}</h3>
                <img src="assets/images/body/tours/mas.svg" style="cursor: pointer;" (click)="plusLessAdult(true,false)"
                  alt="">
              </div>

            </div>
          </div>
          <div class="row mb-4 me-0 ms-0">
            <div class=" col-lg-3 col-6">
              <h3 class="mb-0 pe-3">Niños</h3>
              <p class="mb-0">(De {{tourDetail?.edad_desde}} a {{tourDetail?.edad_hasta}} años)</p>
            </div>
            <div class="col-lg-9 col-6">
              <div class="d-flex flex-row">
                <img src="assets/images/body/tours/menos.svg" style="cursor: pointer;"
                  (click)="plusLessTeenger(false,true)" class=" pe-2" alt="">
                <h3 class="mb-0 pe-2">{{reservation?.menores}}</h3>
                <img src="assets/images/body/tours/mas.svg" (click)="plusLessTeenger(true,false)"
                  style="cursor: pointer;" alt="">
              </div>

            </div>
          </div>
          <div class="row mb-4 me-0 ms-0">
            <div class=" col-lg-3 col-6">
              <h3 class="mb-0 pe-3">Bebes</h3>
            </div>
            <div class="col-lg-9 col-6">
              <div class="d-flex flex-row">
                <img src="assets/images/body/tours/menos.svg" style="cursor: pointer;"
                  (click)="plusLessBaby(false,true)" class=" pe-2" alt="">
                <h3 class="mb-0 pe-2">{{reservation?.bebes}}</h3>
                <img src="assets/images/body/tours/mas.svg" style="cursor: pointer;" (click)="plusLessBaby(true,false)"
                  alt="">
              </div>              
            </div>
          </div>
          <div class="pt-1 text-danger" *ngIf="errorPasajeros!=='' && submitted">
            <div>{{errorPasajeros}}</div>                            
          </div>
        </div>        
      </div>

    </div>


  </div>
</section>
<section class="">
  <div class="container-fluid pb-5 pt-5">
    <div class="row d-flex">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-lg-4 z-index-top position-relative mb-3 mb-lg-0 ">
        <div class="bg-primary tours-pasajeros ps-0 pb-5 h-100 d-flex flex-column justify-content-between pe-2">
          <h4 class="align-items-center bg-white d-flex text-primary title-bg">Paso 2 - Transporte <img
              src="assets/images/body/tours/transporte.svg" class="ps-4" alt=""></h4>
          <div class="ps-5 pt-3">
            <h2 class="text-white mb-1">Elegir asientos</h2>
            <p class="text-white">Seleccione los asientos en donde desea viajar</p>
          </div>
          <div class="ps-5 pt-3">
            <p class="text-white mb-0">Tipo de transporte</p>
            <h3 class="text-white mb-1">{{tourDetail?.id_tipoBus?.tipo}}</h3>
          </div>

        </div>
      </div>



      <div class="col-lg-8 col-xl-7 col-xxl-6 margin-left- bg-grey">

        <div *ngIf="tourDetail?.id_tipoBus?.tipo === 'Minibus'" class="row bg-grey">
          <app-minibus [asientosSelected]="selectedSeats" [asientosInic]="allReservedSeat" [bloqueado]="bloqueado"></app-minibus>
        </div>
        <div *ngIf="tourDetail?.id_tipoBus?.tipo === 'Bus semi cama'" class="row bg-grey">
          <app-bus-semicama [asientosSelected]="selectedSeats" [asientosInic]="allReservedSeat" [bloqueado]="bloqueado"></app-bus-semicama>
        </div>
        <div *ngIf="tourDetail?.id_tipoBus?.tipo === 'Bus mix'" class="row bg-grey">
          <app-coche-mix [asientosSelected]="selectedSeats" [asientosInic]="allReservedSeat" [bloqueado]="bloqueado"></app-coche-mix>
        </div>  
        <div class="pt-1 text-danger mb-2" *ngIf="submitted && hasErrorSeats()">
          <div>{{errorAsientos}}</div>                            
        </div>      
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">

      </div>
    </div>
  </div>
</section>
<section class="">
  <div class="container-fluid">

    <div class="row d-flex">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-lg-4 z-index-top position-relative mb-3 mb-lg-0 ">
        <div
          class="align-items-baseline flex-column flex-lg-row align-items-lg-center bg-primary d-flex h-100 pb-5 position-relative ps-0 tours-pasajeros">
          <h4 class="align-items-center bg-white d-flex text-primary title-bg hotel-title top-0">Paso 3 - Hotel <img
              src="assets/images/body/tours/hotel-title.svg" class="ps-4" alt=""></h4>
          <div class="ps-5 pt-3">

            <h2 class="text-white mb-1">Hotel {{hotel?.nombre_hotel}}</h2>
            <p class="text-white">Seleccione tipo de habitación</p>
            <li class="d-flex align-items-center pb-3">
              <div *ngFor="let item of hotelStar">
                <div *ngIf="item===1">
                  <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="18.363" height="17.512"
                    viewBox="0 0 18.363 17.512">
                    <path class="estrella-active-3"
                      d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z"
                      transform="translate(-1.583 -1.583)" fill="none" stroke="#fff" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="1" /></svg>
                </div>
                <div *ngIf="item===0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="18.363" height="17.512"
                    viewBox="0 0 18.363 17.512">
                    <path
                      d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z"
                      transform="translate(-1.583 -1.583)" fill="none" stroke="#fff" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="1" /></svg>
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>

      <div class="col-lg-8 col-xl-7 col-xxl-6 margin-left- pe-lg-0 z-index--top">
        <div class="ps-4 pt-5 pb-4 bg-grey">
          <div class="row mb-4 me-0 ms-0">
            <div class="col-lg-6 col-12">
              <div class="row">
                <div class="col-lg-12 col-12">
                  <p class="mb-3">Tipos de habitación</p>
                </div>
              </div>
              <div class="row mb-5" *ngIf="hasThisRoomType('Individual')">
                <div class="col-lg-6 col-6">
                  <h3 class="mb-0 pe-3">Individual</h3>
                </div>
                <div class="col-lg-6 col-6">
                  <div class="d-flex flex-row">
                    <img style="cursor: pointer;"  src="assets/images/body/tours/menos.svg" (click)="plusLessIndividual(false,true)" class=" pe-2" alt="">
                    <h3 class="mb-0 pe-2">{{reservation?.individual}}</h3>
                    <img style="cursor: pointer;"  src="assets/images/body/tours/mas.svg" (click)="plusLessIndividual(true,false)" alt="">
                  </div>
                </div>
              </div>
              <div class="row mb-5" *ngIf="hasThisRoomType('Doble')">
                <div class=" col-lg-6 col-6">
                  <h3 class="mb-0 pe-3">Doble</h3>
                </div>
                <div class="col-lg-6 col-6">
                  <div class="d-flex flex-row">
                    <img style="cursor: pointer;"  src="assets/images/body/tours/menos.svg" (click)="plusLessDouble(false,true)" class=" pe-2" alt="">
                    <h3 class="mb-0 pe-2">{{reservation?.doble }}</h3>
                    <img style="cursor: pointer;"  src="assets/images/body/tours/mas.svg" (click)="plusLessDouble(true,false)" alt="">
                  </div>

                </div>
              </div>
              <div class="row mb-5" *ngIf="hasThisRoomType('Triple')">
                <div class=" col-lg-6 col-6">
                  <h3 class="mb-0 pe-3">Triple</h3>
                </div>
                <div class="col-lg-6 col-6">
                  <div class="d-flex flex-row">
                    <img style="cursor: pointer;"  src="assets/images/body/tours/menos.svg" (click)="plusLessTripel(false,true)" class=" pe-2" alt="">
                    <h3 class="mb-0 pe-2">{{reservation?.triple}}</h3>
                    <img style="cursor: pointer;"  src="assets/images/body/tours/mas.svg" (click)="plusLessTripel(true,false)" alt="">
                  </div>

                </div>
              </div>
              <div class="row mb-5" *ngIf="hasThisRoomType('Cuadruple')">
                <div class=" col-lg-6 col-6">
                  <h3 class="mb-0 pe-3">Cuadruple</h3>
                </div>
                <div class="col-lg-6 col-6">
                  <div class="d-flex flex-row">
                    <img style="cursor: pointer;"  src="assets/images/body/tours/menos.svg" (click)="plusLessCuadruple(false,true)"class=" pe-2" alt="">
                    <h3 class="mb-0 pe-2">{{reservation?.cuadruple}}</h3>
                    <img style="cursor: pointer;"  src="assets/images/body/tours/mas.svg" (click)="plusLessCuadruple(true,false)" alt="">
                  </div>

                </div>
              </div>
              <div class="pt-1 text-danger" *ngIf="errorHabitacion!=='' && submitted">
                <div>{{errorHabitacion}}</div>                            
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="row">
                <div class="col-lg-12 col-12">
                  <p class="mb-3">Tipos de cama</p>
                </div>
              </div>
              <div class="row mb-5" *ngIf="hotel?.cama_simple !==0">
                <div class="col-lg-6 col-6">
                  <h3 class="mb-0 pe-3">Twin</h3>
                </div>
                <div class="col-lg-6 col-6" >
                  <div class="d-flex flex-row">
                    <img style="cursor: pointer;"  src="assets/images/body/tours/menos.svg" (click)="plusLessTwin(false,true)" class=" pe-2" alt="">
                    <h3 class="mb-0 pe-2">{{reservation?.twin}}</h3>
                    <img style="cursor: pointer;"  src="assets/images/body/tours/mas.svg" (click)="plusLessTwin(true,false)" alt="">
                  </div>
                </div>
              </div>
              <div class="row mb-5" *ngIf="hotel?.cama_doble !==0">
                <div class=" col-lg-6 col-6">
                  <h3 class="mb-0 pe-3">Matrimonial</h3>
                </div>
                <div class="col-lg-6 col-6">
                  <div class="d-flex flex-row">
                    <img style="cursor: pointer;"  src="assets/images/body/tours/menos.svg" (click)="plusLessMatrimonial(false,true)" class=" pe-2" alt="">
                    <h3 class="mb-0 pe-2">{{reservation?.matrimonial}}</h3>
                    <img style="cursor: pointer;"  src="assets/images/body/tours/mas.svg" (click)="plusLessMatrimonial(true,false)" alt="">
                  </div>

                </div>
              </div>
              <div class="pt-1 text-danger" *ngIf="errorCama!=='' && submitted">
                <div>{{errorCama}}</div>                            
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>


  </div>
</section>
<section class="bg-home bg-tour-details">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center z-index--top">
        <a style="cursor: pointer;"  (click)="goReservation()" [ngClass]="reservation?.adultos===0? 'isDisabled': ''"
          class="btn btn-lg rounded-pill btn-primary text-white text-center align-self-center">Reservar</a>
      </div>
    </div>
  </div>
</section>
